/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_AddInputs */

const en_notes_add = /** @type {(inputs: Notes_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add note`)
};

const pt_br2_notes_add = /** @type {(inputs: Notes_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar anotação`)
};

/**
* | output |
* | --- |
* | "Add note" |
*
* @param {Notes_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_add = /** @type {((inputs?: Notes_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_add(inputs)
	return pt_br2_notes_add(inputs)
});